import { FilterKeyVal } from '../internal/types';

type KeyValTuple = [string, unknown];

const isTruthy = ([_, value]: KeyValTuple) => !!value;
const isNotArray = ([_, value]: KeyValTuple) => !Array.isArray(value);

const toAlgoliaFilter = ([key, value]: KeyValTuple) => `${key}:${value}`;

export const transformFilterKeyVal = (filter: FilterKeyVal) =>
  Object.entries(filter).filter(isTruthy).filter(isNotArray).map(toAlgoliaFilter);
